<div class="container-fluid">
  <h2 class="mb-4" i18n="heading|Page title for uploading timesheets@@uploadTimesheetTitle">
    Upload signed timesheet
  </h2>
  <div class="card mb-4 p-3">
    <div
      class="card-title"
      i18n="label|Instruction to select the date for timesheet upload@@selectMonthLabel"
    >
      Select month
    </div>
    <abc-month-year-selector [(year)]="selectedYear" [(month)]="selectedMonth" />
  </div>
  <hr />

  <div>
    @if (tasks() !== null) {
      @for (task of filteredTasks(); track task.projectId) {
        <abc-upload-time-sheet-card
          [task]="task"
          [year]="selectedYear()"
          [month]="selectedMonth()"
        ></abc-upload-time-sheet-card>
      } @empty {
        <div class="text-center py-4 text-muted">
          <i class="bi bi-info-circle me-2"></i>
          <span
            i18n="
              message|Message displayed when no tasks are available for upload and
              acceptance@@noTasksFound"
          >
            No timesheets requiring signing were found this month.
          </span>
        </div>
      }
    } @else {
      <div class="d-flex justify-content-center align-items-center py-5">
        <span
          class="spinner-border spinner-border-lg text-primary"
          role="status"
          aria-hidden="true"
        ></span>
      </div>
    }
  </div>
</div>
